// startup
// Load entry module and return exports
// This entry module used 'module' so it can't be inlined
__webpack_require__("./node_modules/core-js/features/object/assign.js");
__webpack_require__("./node_modules/core-js/features/string/includes.js");
__webpack_require__("./node_modules/promise-polyfill/src/index.js");
var __webpack_exports__ = __webpack_require__("./app/index.jsx");
